import { BlogPostContent } from '@/types/blog';
import { intro } from './sections/intro';
import { persoenlicheVerbindung } from './sections/persoenliche-verbindung';
import { wer_war_kostolany } from './sections/wer-war-kostolany';
import { vier_gs } from './sections/vier-gs';
import { ei_des_kostolany } from './sections/ei-des-kostolany';
import { schlaftabletten_strategie } from './sections/schlaftabletten-strategie';
import { buch_empfehlung } from './sections/buch-empfehlung';
import { fazit } from './sections/fazit';

export const content: BlogPostContent = {
  sections: [
    intro,
    persoenlicheVerbindung,
    wer_war_kostolany,
    vier_gs,
    ei_des_kostolany,
    schlaftabletten_strategie,
    buch_empfehlung,
    fazit
  ]
};